import { ProjectsContainer } from "../Containers/ProjectsContainer"

export const ProjectsViewer = () => {
    return(
        <div>
            <ProjectsContainer/>
        </div>
    ) 
}